<template>
  <div id="modal" v-if="!modalCookie && display">
    <div class="modal__overlay" v-if="modal"></div>
    <transition name="fade">
      <div class="modal modal__welcome" v-if="modal">
        <span class="modal__title">{{ title }}</span>
        <div class="modal__content" v-html="text"></div>
        <button class="button" @click="closeModal">{{ button }}</button>
      </div>
    </transition>
  </div>
</template>

<script>
  /* global cgy_vars */
  /* eslint no-undef: "error" */

  // import store from '../store/store'

  export default {
    name: 'modal',
    data () {
      return {
        modal: true,
        modalCookie: false,
        display: cgy_vars.popup.display_popup,
        title: cgy_vars.popup.title,
        text: cgy_vars.popup.text,
        button: cgy_vars.popup.button
      }
    },
    mounted () {
      this.checkCookie()
    },
    methods: {
      /**
       * Method to close modal and open panel
       */
      closeModal: function () {
        this.modal = false
        for (var i = 0; i < this.$parent.$children.length; i++) {
          if (this.$parent.$children[i].$options.name === 'panel') {
            this.$parent.$children[i].openPanel()
          }
        }
      },
      /**
       * Set cookie for the modal
       * @param {String} cname
       * @param {Number} exdays
       */
      setCookie: function (cname, exdays) {
        var d = new Date()
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
        var expires = 'expires=' + d.toUTCString()
        document.cookie = cname + '=' + d + ';' + expires + ';path=/'
      },
      /**
       * Get a specific stored cookie
       * @param  {String} cname
       * @return {String}
       */
      getCookie: function (cname) {
        var name = cname + '='
        var ca = document.cookie.split(';')
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i]
          while (c.charAt(0) === ' ') {
            c = c.substring(1)
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
          }
        }
        return ''
      },
      checkCookie: function () {
        var modal = this.getCookie('modal')
        if (modal !== '') {
          this.modalCookie = true
        } else {
          this.setCookie('modal', 1)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Modal.vue?d1baf434